import React, { useState, useEffect } from "react";
import { ABOUT, LANDING } from "../data/siteData";
import ContactForm from "./ContactForm";

function TeamCarousel({ members }) {
  const [active, setActive] = useState(0);
  const [paused, setPaused] = useState(false);
  const len = members.length;

  useEffect(() => {
    if (paused) return;
    const timer = setInterval(() => setActive((p) => (p + 1) % len), 4000);
    return () => clearInterval(timer);
  }, [len, paused]);

  const goPrev = () => setActive((p) => (p - 1 + len) % len);
  const goNext = () => setActive((p) => (p + 1) % len);

  return (
    <div
      className="team-carousel-wrap"
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
    >
      <button className="team-carousel-arrow team-arrow-left" onClick={goPrev} aria-label="Previous">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M15 18l-6-6 6-6" />
        </svg>
      </button>
      <div className="team-carousel">
        {members.map((m, i) => {
          const diff = ((i - active + len) % len);
          let cls = "team-carousel-item";
          if (diff === 0) cls += " tc-center";
          else if (diff === 1) cls += " tc-right";
          else if (diff === len - 1) cls += " tc-left";
          else cls += " tc-hidden";
          return (
            <div key={i} className={cls}>
              <div className="team-carousel-img">
                <img src={m.image} alt={m.name} />
              </div>
              <h4 className="team-carousel-name">{m.name}</h4>
              <span className="team-carousel-role">{m.role}</span>
              <p className="team-carousel-desc">{m.desc}</p>
            </div>
          );
        })}
      </div>
      <button className="team-carousel-arrow team-arrow-right" onClick={goNext} aria-label="Next">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M9 18l6-6-6-6" />
        </svg>
      </button>
    </div>
  );
}

export default function AboutPage() {
  const d = ABOUT;

  useEffect(() => {
    document.title = "About | Rising Sun Globalized Firm";
    return () => { document.title = "Rising Sun Globalized Firm | Global IT & AI Solutions"; };
  }, []);

  return (
    <>
      {/* Hero */}
      <section className="about-hero-section">
        <div className="about-hero-overlay" />
        <div className="about-hero-container">
          <p className="about-hero-label">{d.hero.label}</p>
          <div className="about-hero-flex">
            <h1 className="about-hero-heading">
              {d.hero.heading[0]}<br />{d.hero.heading[1]}
            </h1>
            <div className="about-hero-right-desc">
              <p>{d.hero.description}</p>
            </div>
          </div>
        </div>
      </section>

      {/* Vision */}
      <section className="section about-vision-section">
        <h2>Our Vision</h2>
        <p className="section-subtitle">{d.vision.text}</p>
        <div className="about-vision-wrap">
          <div className="about-vision-glow" />
          <div className="about-vision-single-card">
            <div className="about-vision-card-header">
              <h3>{d.visionCard.title}</h3>
              <img className="about-vision-icon" src={d.visionCard.icon} alt="" />
            </div>
            <p>{d.visionCard.text}</p>
          </div>
        </div>
      </section>

      {/* Approach */}
      <section className="section">
        <h2>{d.approach.title}</h2>
        <p className="section-subtitle">{d.approach.subtitle}</p>
        <div className="approach-grid">
          {d.approach.steps.map((step, i) => (
            <div key={i} className={`approach-card${i % 2 !== 0 ? " offset" : ""}`}>
              <div className="approach-card-header">
                <h3>{step.title}</h3>
                <img className="approach-icon" src={step.icon} alt="" />
              </div>
              <p>{step.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Team */}
      <section className="landing-team" style={{ display: "none" }}>
        <div className="landing-team-container">
          <div className="landing-team-header">
            <p className="landing-team-label">{d.team.label}</p>
            <h2 className="landing-team-title">{d.team.title}</h2>
            <p className="landing-team-subtitle">{d.team.subtitle}</p>
          </div>
          <TeamCarousel members={LANDING.team.members} />
        </div>
      </section>

      {/* Testimonials — commented out, will apply later */}

      <ContactForm />
    </>
  );
}
